var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.961,
    viewBox: "0 0 15 14.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#004cff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2024.775,228.746a7.481,7.481,0,1,0,7.5,7.48A7.505,7.505,0,0,0,2024.775,228.746Zm0,14.311a6.83,6.83,0,1,1,0-13.66,6.83,6.83,0,1,1,0,13.66Z",
    transform: "translate(-2017.275 -228.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2027.123,234.045a.364.364,0,0,0-.334-.233.313.313,0,0,0-.34.238l-2.958,3.163a.4.4,0,0,0,0,.45.331.331,0,0,0,.421,0l2.526-2.7v6.708q0,.291.351.291a.314.314,0,0,0,.351-.291v-6.752l2.526,2.745a.4.4,0,0,0,.234.05.269.269,0,0,0,.187-.05.4.4,0,0,0,0-.45Z",
    transform: "translate(-2019.289 -230.406)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.d7fdb481.svg";
export { ForwardRef as ReactComponent };